import React from 'react';

import style from './style.module.less';
import FulfillmentPlannerContextShippingServiceSelector from '../../../../../components/shipping-service-selector/fulfillment-planner-context-shipping-service-selector';
import { useEnableShippingServiceSearchableDropdownInSidebar } from '../../../../../feature-flags/hooks/use-enable-shipping-service-searchable-dropdown-in-sidebar';
import FedexHalShipmentTooltip from '../../../../../fulfillment-planner/shipping-service/fedex-hal-shipment-tooltip';
import ShippingServiceLabel from '../../../../../fulfillment-planner/shipping-service/label';
import { ServiceGroupSelector } from '../../../../../fulfillment-planner/shipping-service/service-group-selector';
import { useIsFedexHALByFulfillmentPlanId } from '../../../../../hooks/orders/use-fedex-hal-check';
import { usePickupRelayOrderInfoByFulfillmentPlanId } from '../../../../../hooks/orders/use-pickup-relay-order-check';
import PickupRelayTooltip from '../../../../../orders/customer-recipient-widget/pickup-relay-tooltip';

/**
 * @param {object} props
 * @param {string} props.fulfillmentPlanId
 * @returns {React.JSX.Element}
 */
const ShippingService = ({ fulfillmentPlanId }) => {
  const isFedexHalShipment = useIsFedexHALByFulfillmentPlanId(fulfillmentPlanId);
  const isPickupRelayOrder = usePickupRelayOrderInfoByFulfillmentPlanId(fulfillmentPlanId) !== null;
  const isSearchable = useEnableShippingServiceSearchableDropdownInSidebar();

  return (
    <>
      <div className={style.label}>
        {isFedexHalShipment ? <FedexHalShipmentTooltip /> : null}
        {isPickupRelayOrder ? <PickupRelayTooltip isShippingServiceInstance /> : null}
        <ShippingServiceLabel />
      </div>
      <FulfillmentPlannerContextShippingServiceSelector
        dropdownMenuShouldHaveWidthOfButton
        fulfillmentPlanId={fulfillmentPlanId}
        hasLabelOverFlow
        isSearchable={isSearchable}
        showBestWayToShip
      />
      <div className={style.center}>
        <ServiceGroupSelector />
      </div>
    </>
  );
};

export default ShippingService;
